export const convertMegabyteToByte = (value: number): number => 1024 * 1024 * value;
